

export const system = [
    {
        path: '/system',
        name: '系统管理',
        redirect: '/system/supervise',
        component: () => import("@/views/layout/index.vue"),
        children: [
            {
                path: 'supervise',
                component: () => import("@/views/sellerAdmin/marketing/system/supervise/index.vue"),
                name: '管理员',
                meta: {
                    hidden: true,
                    key: 6001,
                },
            },
            {
                path: 'rights-group',
                component: () => import("@/views/sellerAdmin/marketing/system/rights-group/index.vue"),
                name: '权限组',
                meta: {
                    hidden: true,
                    key: 6002,
                },
            },
            {
                path: 'logs',
                component: () => import("@/views/sellerAdmin/marketing/system/logs/index.vue"),
                name: '操作日志',
                meta: {
                    hidden: true,
                    key: 6003,
                },
            },
            {
                path: 'platform',
                component: () => import("@/views/sellerAdmin/marketing/system/platform/index.vue"),
                name: '开放平台',
                meta: {
                    hidden: true,
                    key: 6003,
                },
            },
        ]
    },

]